import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { LocalAuthority } from '../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class LocalAuthoritiesService {
    constructor(private http: HttpClient) {}
    public getLocalAuthorities(cities: string[]): Observable<LocalAuthority[]> {
        return this.http.post<LocalAuthority[]>(`${environment.apiUri}/local-authorities`, { cities });
    }
}
